import HoneyJar from "../images/beesProductNice.jpg";
export default [
  {
    _id: 1,
    name: "Raw Honey",
    weight: "100g",
    image: HoneyJar,
    description:
      "Delicious, good tasting honey that is truly raw and great for your health!",
      price: 10
  },
  {
    _id: 2,
    name: "Raw Honey",
    weight: "250g",
    image: HoneyJar,
    description:
      "Delicious, good tasting honey that is truly raw and great for your health!",
      price: 25
  },
  {
    _id: 3,
    name: "Raw Honey",
    weight: "500g",
    image: HoneyJar,
    description:
      "Delicious, good tasting honey that is truly raw and great for your health!",
      price: 50
  },

  {
    _id: 4,
    name: "Raw Honey",
    weight: "700g",
    image: HoneyJar,
    description:
      "Delicious, good tasting honey that is truly raw and great for your health!",
      price: 70
  }
];



// WEBPACK FOOTER //
// ./src/content/products.js